module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-00.45968678.png";